import moment from 'moment'
export default {
    ADD_SEGMENT (state, item) {
        state.employeeFiledTimeSheet.unshift(item)
        //console.log('ADD_SEGMENT ' + item.employeeFiledTimeSheetId)
        const data = {
          id: item.employeeFiledTimeSheetId,
          title: moment(item.badgeTimeIn).format('MM/DD/YYYY hh:mm:ss A'),
          startDate: moment(item.badgeTimeIn).format('YYYY-MM-DD'),
          endDate: moment(item.badgeTimeIn).format('YYYY-MM-DD'),
          url: '',
          classes: item.segmentTypeId == 2 ? 'event-success': item.segmentTypeId == 5 ? 'event-primary' : item.segmentTypeId == 3 ? 'event-danger' : 'event-warning',
          label: item.segmentTypeId == 2 ? 'Clock-In': item.segmentTypeId == 5 ? 'Clock-Out' : item.segmentTypeId == 3 ? 'Break-Out' : 'Break-In',
          segmentTypeId: item.segmentTypeId,
          employeeScheduleId: item.employeeScheduleId
          
        }
        // switch (item.segmentTypeId){
        //   case 2:
        //     //console.log('pasok sa banga')
        //     state.clockIn = item.badgeTimeIn,
        //     state.isDisabled = true,
        //     state.isBreak = false
        //     break;
        //   case 4:
        //     state.breakOut = item.badgeTimeIn,
        //     state.isDisabled = !state.isDisabled,
        //     state.isBreak = !state.isBreak
        //     break;
        //   case 5:
        //     state.breakIn = item.badgeTimeIn,
        //     state.isDisabled = !state.isDisabled,
        //     state.isBreak = !state.isBreak
        //     break;
        //   case 3:
        //     state.clockOut = item.badgeTimeIn,
        //     state.isDisabled = false,
        //     state.isBreak = false
        //     break;
        // }

        state.calendarEvents.push(data)
    },
    CURRENT_SCHEDULE(state, schedule) {

      state.employeeSchedule = JSON.parse(schedule)
      //console.log(state.employeeSchedule)  
    },
    GETALLSCHEDULENOTCLOSED(state, schedule){
      state.employeeSchedule = JSON.parse(schedule)
    },
    GET_ALL_SEGMENT(state, segments) {
      state.employeeFiledTimeSheet = segments
        if(state.calendarEvents.length == 0) {
          for (var x = 0; x < segments.length; x++)
          {
              var s = {
            
              id: segments[x].employeeFiledTimeSheetId,
              title: moment(segments[x].badgeTimeIn).format('MM/DD/YYYY hh:mm:ss A'),
              startDate: moment(segments[x].badgeTimeIn).format('YYYY-MM-DD'),
              endDate: moment(segments[x].badgeTimeIn).format('YYYY-MM-DD'),
              url: '',
              classes: segments[x].segmentTypeId == 2 ? 'event-success': segments[x].segmentTypeId == 5 ? 'event-danger' : segments[x].segmentTypeId == 3 ? 'event-warning' : 'event-primary',
              label: segments[x].segmentTypeId == 2 ? 'Clock-In': segments[x].segmentTypeId == 5 ? 'Clock-Out' : segments[x].segmentTypeId == 3 ? 'Break-Out' : 'Break-In',
              segmentTypeId: segments[x].segmentTypeId,
              employeeScheduleId: segments[x].employeeScheduleId
          
            }
            state.calendarEvents.push(s) 
          
            
          }
        }
        
    },
   
    // SET_LATEST_SEGMENT(state, item) {
    //   state.latestSegments.push(item)
    // }
}